import React from 'react';
import { Button } from './ui/button';
import { TrendingUp, Shield, Zap } from 'lucide-react';

const FeaturesSection = () => {
  const features = [
    {
      icon: TrendingUp,
      title: 'SWISSBORG Tailor-made',
      subtitle: 'Accompagnement sur mesure',
      description: "Un analyste financier senior vous est personnellement dédié afin de définir une stratégie d'investissement sur mesure, adaptée à vos objectifs et à votre profil. Il en assure également le suivi régulier pour optimiser la performance de votre portefeuille dans la durée.",
      cta: '',
      gradient: 'from-[#01C38D]/20 to-[#00A878]/20',
      image: 'https://images.pexels.com/photos/844124/pexels-photo-844124.jpeg?auto=compress&cs=tinysrgb&w=600'
    },
    {
      icon: Shield,
      title: 'SwissBorg Advanced',
      subtitle: "Produits d'épargne personnalisés",
      description: "Découvrez des solutions d'investissement sur mesure, pensées pour correspondre à votre profil d'investisseur et à vos ambitions financières. Que vous souhaitiez sécuriser votre capital, diversifier vos placements ou dynamiser vos rendements, nous construisons une stratégie claire et efficace, en accord avec vos priorités.",
      cta: '',
      gradient: 'from-[#00A878]/20 to-[#01C38D]/20',
      image: 'https://images.unsplash.com/photo-1559526324-593bc073d938?auto=format&fit=crop&w=600&q=80'
    },
    {
      icon: Zap,
      title: 'SWISSBORG Exclusive member',
      subtitle: 'Avantages exclusifs membres',
      description: "Ici, pas de frais cachés ni de commissions fixes : nous ne sommes rémunérés que sur vos résultats. Notre objectif est le même que le vôtre — faire croître votre capital. C'est une véritable relation de confiance et de performance partagée, où chaque décision vise un seul but : vous faire gagner.",
      cta: '',
      gradient: 'from-[#01C38D]/20 to-teal-500/20',
      image: 'https://images.unsplash.com/photo-1554260570-e9689a3418b8?auto=format&fit=crop&w=600&q=80'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="space-y-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              {/* Content */}
              <div className={`space-y-6 ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="inline-block">
                  <feature.icon className="w-12 h-12 text-[#01C38D]" />
                </div>
                <div>
                  <p className="text-[#01C38D] font-semibold mb-2 tracking-wide uppercase text-sm">
                    {feature.title}
                  </p>
                  <h2 className="text-4xl font-bold text-gray-900 mb-4">{feature.subtitle}</h2>
                  <p className="text-gray-600 text-lg">{feature.description}</p>
                </div>
                {feature.cta && (
                  <Button className="bg-[#01C38D] hover:bg-[#00A878] text-white">
                    {feature.cta}
                  </Button>
                )}
              </div>

              {/* Visual */}
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div
                  className={`relative bg-gradient-to-br ${feature.gradient} rounded-3xl p-2 border border-[#01C38D]/30 shadow-xl h-96 flex items-center justify-center overflow-hidden`}
                >
                  {/* Image */}
                  <img 
                    src={feature.image} 
                    alt={feature.subtitle}
                    className="w-full h-full object-cover rounded-2xl"
                  />
                  {/* Overlay gradient */}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#01C38D]/20 to-transparent rounded-2xl"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
